const base = "cui-iconbutton-xjpq";
const s = "cui-iconbutton-s-amzq";
const m = "cui-iconbutton-m-9nqy";
const classes = {
  base,
  s,
  m
};
export {
  base,
  classes as default,
  m,
  s
};
